// Chapter 3 story events (Dana in the mountain).
export const CH3_OPEN = {
  id: "iron_stairs:event:open", room: "iron_stairs", title: "Down Into the Mountain",
  text: "I followed Samantha down the stairs behind the iron door. Joe stayed with the kids.",
  lines: [
    { text: "CHAPTER THREE — ARRIVAL" },
    { text: "Dana. The iron door closes somewhere above her. The stairs keep going down, and down, into the mountain." },
    { who: "Samantha", text: "Watch your step. They're old. Older than the cabin. Older than the institute." },
    { who: "Dana", text: "Great. Love that for me." },
  ],
};

export const CHAMBER = {
  id: "chamber:event:dagger", room: "chamber", title: "The Sacrificial Chamber",
  text: "Samantha told me the only way to stop Romulus and Remus: they lose their power in this room, and the dagger draws them here. If we die by our own hand just as they enter, they are destroyed.",
  lines: [
    { text: "Behind the carved door is a round chamber cut out of the rock. A stone altar stands in the middle. On it lies a dagger that seems to drink the candlelight." },
    { who: "Samantha", text: "I didn't want to mention this before. There's only one way to stop Romulus and Remus." },
    { who: "Samantha", text: "When they enter this room, their power is stripped away from them. Everything they are, gone. Just for a moment." },
    { who: "Samantha", text: "And they will want to come in here. That dagger holds tremendous power for the rituals. With it, they could summon an eldritch god of their own choosing." },
    { who: "Dana", text: "So we hide it. We take it and we run." },
    { who: "Samantha", text: "No. We use it." },
    { who: "Samantha", text: "If we sacrifice ourselves, if we die just as Romulus and Remus enter the room, they will be destroyed." },
    { who: "Samantha", text: "And there is a good chance the benevolent god we have been trying to summon for thirty years will come through." },
  ],
};

export const CULT = {
  id: "chamber:event:cult", room: "chamber", title: "Two Minutes",
  text: "Samantha's people will slow Romulus and Remus down. A cut with the dagger takes two minutes to bleed out. They will probably come through the old mine. Dana said she can't do it.",
  lines: [
    { text: "Footsteps. Robed figures file into the chamber one by one, hoods down, lanterns low. They gather around the altar in silence." },
    { who: "Samantha", text: "These are the members of my group who are still mine. They will try to slow Romulus and Remus down." },
    { who: "Samantha", text: "If you cut your wrist with the knife, it takes two minutes to bleed out and die." },
    { who: "Samantha", text: "They will tell us the moment the wolves enter the stairs. Then they will slow them, just enough, so they walk in here at the appointed time." },
    { who: "Dana", text: "Wait. If Romulus and Remus have to get to the top of those stairs, they have to go through the cabin. Through Sarah. Through Joe and your kids." },
    { who: "Samantha", text: "No. There are other ways into that basement, to the top of the stairs." },
    { who: "Samantha", text: "We think they're staying in a town nearby, collecting people to them, to come and take the dagger. They'll most likely come in through the old mine." },
    { text: "Every face in the room turns to Dana. Waiting." },
    { who: "Dana", text: "I can't do that." },
    { who: "Dana", text: "I can't kill myself." },
  ],
};

export const JOE3 = {
  id: "living:event:joe3", room: "living", title: "Back at the Cabin",
  text: "Hours since Dana went down. Joe decided they need a way out: dig out the cars.",
  lines: [
    { text: "Back at the cabin. Joe again. It has been hours since Dana followed Samantha down the stairs." },
    { text: "Sam and Chloe are curled up by the fire. Sarah hasn't stopped staring at the basement door." },
    { who: "Joe", text: "If this goes bad, we need a way out. The cars. We dig them out. Tonight." },
  ],
};

export const AGREE = {
  id: "chamber:event:agree", room: "chamber", title: "Dana Agrees",
  text: "Samantha reminded me what would be lost. That Sarah wouldn't stand a chance. I said yes.",
  lines: [
    { text: "Back in the chamber. Dana. The cult members haven't moved. Neither has the dagger." },
    { who: "Dana", text: "I can't do this. I'm sorry. I can't." },
    { who: "Samantha", text: "Then listen to what happens if you don't." },
    { who: "Samantha", text: "If Romulus and Remus take that dagger, they choose the god that comes through. And their gods do not rest. Towns become hunting grounds. Then cities. Then everything." },
    { who: "Samantha", text: "Everyone you have ever known. Everyone you've ever passed on the street. Hollowed out, like the people following them right now." },
    { who: "Samantha", text: "And Sarah. Sarah is sitting at the top of those stairs. If they get the dagger, she won't stand a chance. None of them will." },
    { text: "Dana closes her eyes. She thinks of Sarah's laugh. The way she says Dana's name when she's half asleep." },
    { who: "Dana", text: "...Okay." },
    { who: "Dana", text: "Okay. I'll do it. For her." },
  ],
};

export const RITUAL = {
  id: "chamber:event:ritual", room: "chamber", title: "The Light Above the Door",
  text: "The cult went to hold the stairs. The light came on almost at once. Samantha and I lay down on the stone and cut our wrists.",
  lines: [
    { text: "Without a word, the cult members file out of the chamber. They take their places on the stairs and in the passageway." },
    { text: "Almost immediately, a light above the door flickers on." },
    { text: "Samantha gasps." },
    { who: "Samantha", text: "They're already at the top of the stairs. They're so fast." },
    { who: "Samantha", text: "Get on the stone with me. Now, Dana." },
    { text: "They climb onto the altar together. The stone is warm, like something alive." },
    { who: "Samantha", text: "Are you ready?" },
    { who: "Dana", text: "No." },
    { text: "They cut their wrists anyway. Then they hold each other, and wait." },
  ],
};

export const FEEL = {
  id: "living:event:feel", room: "living", title: "Can You Feel That?",
  text: "The ground shook. Sarah and I both felt something huge coming.",
  lines: [
    { text: "Back in the cabin. The ground shakes, once, hard. A picture frame falls off the wall." },
    { who: "Sarah", text: "What was that?" },
    { text: "A long moment. Nobody moves." },
    { who: "Joe", text: "Can you feel that?" },
    { who: "Sarah", text: "Yes. I can. I don't understand." },
    { who: "Sarah", text: "It feels like something huge is coming. Something enormous. But I don't understand why I can FEEL it." },
    { text: "Sam and Chloe are already at the front door, pulling on their boots. They're smiling." },
  ],
};

export const FINAL = {
  id: "outside:event:final", room: "outside", title: "The End",
  text: "Something came through. It wasn't what anyone hoped for. Sarah is gone. Joe is still laughing.",
  lines: [
    { text: "Joe lies in the snow, laughing. He can't stop. He doesn't want to." },
    { text: "Above him, the sky keeps opening." },
    { text: "THE END" },
  ],
};

export const CH3_EVENTS = [CH3_OPEN, CHAMBER, CULT, JOE3, AGREE, RITUAL, FEEL, FINAL];
